import { RouteName } from '../Router.types';
import { ProviderType } from '../../../DocumentVault/DocumentVault.meta';

export const getRouteDefaultParamsMap = (clientId: string): Record<string, any> => {
  return {
    [RouteName.Goals]: {
      clientId,
      workflowEnded: false,
    },
    [RouteName.Overview]: { clientId },
    [RouteName.Transactions]: { clientId, accountId: 0 },
    [RouteName.Profile]: { clientId, pivotId: 0, pageId: 'personalinfo' },
    [RouteName.MoneyGuidePro]: { clientId },
    [RouteName.CashFlowReport]: { clientId, mode: '1' },
    [RouteName.DocumentVault]: {
      clientId,
      path: '',
      providerType: ProviderType.All,
    },
    [RouteName.EMoney]: { clientId },
    [RouteName.Schwab]: { clientId },
    [RouteName.RISA]: { clientId },
    [RouteName.OrionTrading]: { clientId },
    [RouteName.DataReconciliation]: { clientId },
    [RouteName.Newsfeed]: { clientId },
    [RouteName.AssetBucketingResults]: { clientId },
    [RouteName.RightCapital]: { clientId },
    [RouteName.NetWorth]: { clientId },
    [RouteName.PulseCheckWorkflow]: { clientId },
    [RouteName.PulseCheckResults]: { clientId },
    [RouteName.GoalTrack]: { clientId },
    [RouteName.BeFi]: { clientId },
  };
};
